// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3R-w0","clinicsSelect":"TableHeading_clinicsSelect__1GpA6"};